import React from 'react';
import { VentroIcon, TwitterIcon, LinkedinIcon, GithubIcon, AppStoreIcon, PlayStoreIcon } from './Icons.tsx';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-100 dark:bg-black/40 border-t border-gray-200 dark:border-gray-800/50 pt-16 pb-8">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-2 mb-8 md:mb-0">
            <a href="#" className="flex items-start gap-2 mb-4">
              <VentroIcon className="h-10 w-10 text-orange-600 dark:text-[#FF4D00]" />
              <div className="flex flex-col pt-2">
                <span className="text-xl font-bold text-gray-900 dark:text-white leading-tight">Shield</span>
                <span className="text-xs text-gray-500 dark:text-white leading-tight">by Ventro</span>
              </div>
            </a>
            <p className="text-gray-700 dark:text-gray-400 max-w-xs">The complete command center for your equipment operations and safety compliance.</p>
            <div className="flex gap-4 mt-6">
                <a href="#" className="text-gray-500 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors"><TwitterIcon className="h-6 w-6" /></a>
                <a href="#" className="text-gray-500 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors"><LinkedinIcon className="h-6 w-6" /></a>
                <a href="#" className="text-gray-500 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors"><GithubIcon className="h-6 w-6" /></a>
            </div>
            <div className="flex gap-3 mt-6">
              <a href="https://apps.apple.com/pl/app/ventro/id6753670953?platform=iphone" target="_blank" rel="noopener noreferrer" aria-label="Download on the App Store" className="inline-block transition-transform hover:scale-105">
                <div className="bg-black dark:bg-white/10 dark:border dark:border-white/20 rounded-lg px-4 py-2 flex items-center gap-2 min-w-[140px]">
                  <AppStoreIcon className="h-7 w-7 text-white dark:text-white" />
                  <div className="flex flex-col">
                    <span className="text-[10px] text-white/80 dark:text-white/60 leading-tight">Download on the</span>
                    <span className="text-sm font-semibold text-white dark:text-white leading-tight">App Store</span>
                  </div>
                </div>
              </a>
              <a href="https://play.google.com/store/apps/details?id=energy.ventro" target="_blank" rel="noopener noreferrer" aria-label="Get it on Google Play" className="inline-block transition-transform hover:scale-105">
                <div className="bg-black dark:bg-white/10 dark:border dark:border-white/20 rounded-lg px-4 py-2 flex items-center gap-2 min-w-[140px]">
                  <PlayStoreIcon className="h-7 w-7 text-white dark:text-white" />
                  <div className="flex flex-col">
                    <span className="text-[10px] text-white/80 dark:text-white/60 leading-tight">GET IT ON</span>
                    <span className="text-sm font-semibold text-white dark:text-white leading-tight">Google Play</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div>
            <h5 className="font-semibold text-gray-900 dark:text-white mb-4">Product</h5>
            <ul className="space-y-3">
              <li><a href="#features" className="text-gray-700 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors">Features</a></li>
              <li><a href="#techstack" className="text-gray-700 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors">Integrations</a></li>
              <li><a href="#cta" className="text-gray-700 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors">Security</a></li>
            </ul>
          </div>
          <div>
            <h5 className="font-semibold text-gray-900 dark:text-white mb-4">Company</h5>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-700 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors">About Us</a></li>
              <li><a href="#" className="text-gray-700 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors">Blog</a></li>
              <li><a href="#" className="text-gray-700 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>
          <div>
            <h5 className="font-semibold text-gray-900 dark:text-white mb-4">Resources</h5>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-700 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors">Documentation</a></li>
              <li><a href="#" className="text-gray-700 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors">API Status</a></li>
              <li><a href="#" className="text-gray-700 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors">Case Studies</a></li>
              <li><a href="#" className="text-gray-700 dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors">Whitepapers</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800/50 flex flex-col sm:flex-row justify-between items-center text-sm text-gray-600 dark:text-gray-400">
          <p>&copy; 2024 - 2025 Ventro Inc. All rights reserved.</p>
          <div className="flex gap-4 mt-4 sm:mt-0">
            <a href="#" className="hover:text-black dark:hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-black dark:hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;